import { api } from '../../../api/Middleware';

const API_URL = process.env.REACT_APP_API_URL;
const BASE = `${API_URL}agents_flow/agents`;

const WhatsAppCloudApiService = {
  connect(agentId, data) {
    return api.post(`${BASE}/${agentId}/cloud-api/connect/`, data);
  },

  connectManual(agentId, data) {
    // data: { waba_id, phone_number_id, access_token }
    return api.post(`${BASE}/${agentId}/cloud-api/connect-manual/`, data);
  },

  disconnect(agentId) {
    return api.post(`${BASE}/${agentId}/cloud-api/disconnect/`);
  },

  /**
   * Pausa (status=0) ou reativa (status=1) respostas do agente IA
   * no número Cloud API. Webhook Meta segue ativo — mensagens continuam
   * aparecendo na Central, só sem resposta automática.
   */
  pauseOrActivate(agentId, statusNum) {
    return api.post(
      `${BASE}/${agentId}/cloud-api/pause-or-active/`,
      { status: statusNum },
    );
  },

  getStatus(agentId) {
    return api.get(`${BASE}/${agentId}/cloud-api/status/`);
  },

  /**
   * Lista templates com filtros opcionais.
   * Sem filtros = todos os status (incluindo PENDING/REJECTED).
   * Filtros aceitos: status, category, language, search, approved_only.
   */
  getTemplates(agentId, { page = 1, pageSize = 20, status, category, language, search, approvedOnly } = {}) {
    const params = { page, page_size: pageSize };
    if (status && status !== 'all') params.status = status;
    if (category && category !== 'all') params.category = category;
    if (language) params.language = language;
    if (search) params.search = search;
    if (approvedOnly) params.approved_only = 1;
    return api.get(`${BASE}/${agentId}/cloud-api/templates/`, { params });
  },

  syncTemplates(agentId) {
    return api.post(`${BASE}/${agentId}/cloud-api/templates/sync/`);
  },

  getProfile(agentId) {
    return api.get(`${BASE}/${agentId}/cloud-api/profile/`);
  },

  updateProfile(agentId, data) {
    return api.put(`${BASE}/${agentId}/cloud-api/profile/`, data);
  },

  sendTemplate(agentId, data) {
    return api.post(`${BASE}/${agentId}/cloud-api/send-template/`, data);
  },

  /**
   * Cria template novo na Meta.
   * payload: { name, language, category, components }
   */
  createTemplate(agentId, payload) {
    return api.post(`${BASE}/${agentId}/cloud-api/templates/create/`, payload);
  },

  /**
   * Deleta template por nome (todas as línguas).
   * Para deletar apenas uma língua específica, passe templateId.
   *
   * Usa URL `templates/by-name/{name}` para evitar conflito de rota com
   * `templates/sync` e `templates/create` (DRF router ordena alfabeticamente
   * e o catch-all engoliria essas URLs).
   */
  deleteTemplate(agentId, templateName, templateId = null) {
    const params = templateId ? { template_id: templateId } : {};
    return api.delete(
      `${BASE}/${agentId}/cloud-api/templates/by-name/${encodeURIComponent(templateName)}/`,
      { params },
    );
  },

  /**
   * Atualiza categoria de template aprovado.
   * Meta só aceita após APPROVED.
   */
  updateTemplateCategory(agentId, templateId, category) {
    return api.post(
      `${BASE}/${agentId}/cloud-api/templates/${encodeURIComponent(templateId)}/update-category/`,
      { category },
    );
  },
};

export default WhatsAppCloudApiService;
